import { createCatalogEndpoint, createCrudEndpoints } from '@/core/utils'
import {
  TCities,
  TComments,
  TFiles,
  TInvitation,
  TInvitations,
  TLeads,
  TSellers,
  TStates,
} from '.'
import { TFilters } from '@/core/types'
import { toValue } from 'vue'
import api from '@/core/config/axios'

export const serviceConfig = {
  model: 'invitations',
  version: 'v1',
  states: {
    model: 'states',
    version: 'v1',
  },
  cities: {
    model: 'cities',
    version: 'v1',
  },
  leads: {
    model: 'leads',
    version: 'v1',
  },
  sellers: {
    model: 'sellers',
    version: 'v1',
  },
  comments: {
    model: 'follow-ups',
    version: 'v1',
  },
  files: {
    model: 'files',
    version: 'v1',
  },
}
const { states, cities, leads, sellers, comments, files } = serviceConfig

const { loadRecords } = createCrudEndpoints<TInvitations, TInvitation>(
  serviceConfig.model,
  serviceConfig.version,
)

const statesCatalog = createCatalogEndpoint<TStates>(
  states.model,
  states.version,
)

const citiesCatalog = createCatalogEndpoint<TCities>(
  cities.model,
  cities.version,
)

const leadsCatalog = createCatalogEndpoint<TLeads>(leads.model, leads.version)

const sellersCatalog = createCatalogEndpoint<TSellers>(
  sellers.model,
  sellers.version,
)

const moduleServiceHandlers = {
  loadRecords,
  loadEstimationComments: async (params: TFilters): Promise<TComments> => {
    const urlSearchParams = [
      `page=${toValue(params.page) ?? 1}`,
      toValue(params.dynamicFilters ?? ''),
    ]
      .filter(Boolean)
      .join('&')

    return api
      .get(
        `${comments.version}/${comments.model}-estimation?${urlSearchParams}`,
      )
      .then((response) => response.data)
  },
  loadSellerComments: async (params: TFilters): Promise<TComments> => {
    const urlSearchParams = [
      `page=${toValue(params.page) ?? 1}`,
      toValue(params.dynamicFilters ?? ''),
    ]
      .filter(Boolean)
      .join('&')

    return api
      .get(`${comments.version}/${comments.model}-seller?${urlSearchParams}`)
      .then((response) => response.data)
  },
  loadFiles: async (params: TFilters): Promise<TFiles> => {
    const urlSearchParams = [
      `page=${toValue(params.page) ?? 1}`,
      toValue(params.dynamicFilters ?? ''),
    ]
      .filter(Boolean)
      .join('&')

    return api
      .get(`${files.version}/${files.model}?${urlSearchParams}`)
      .then((response) => response.data)
  },
}

const catalogServiceHandlers = {
  statesCatalog,
  citiesCatalog,
  leadsCatalog,
  sellersCatalog,
}

export { moduleServiceHandlers, catalogServiceHandlers }
